/**
 * @fileoverview
 * Functions to access persisted player state.
 */
import { SOFT_PIP_PLAYER_STATE_KEY } from '@core/pictureInPicture/constants';
import { getSessionStorage } from '@core/storage/getStorage';
/**
 * Clear the persisted Soft PIP player state but keep the entry URL.
 */
export function clearPersistedPlayerStateSansEntryUrl() {
    const previousState = getPersistedPlayerState();
    clearPersistedPlayerState();
    if (previousState) {
        setPersistedPlayerState({
            appContextType: previousState.appContextType,
            createdAt: previousState.createdAt,
            entryUrl: previousState.entryUrl,
        });
    }
}
/**
 * Store the Soft PIP player state in session storage.
 * @param value - The Soft PIP player state to store.
 */
export function setPersistedPlayerState(value) {
    getSessionStorage().setItem(SOFT_PIP_PLAYER_STATE_KEY, JSON.stringify(value));
}
/**
 * Get the Soft PIP player state from session storage.
 * @returns The Soft PIP player state.
 */
export function getPersistedPlayerState() {
    const value = getSessionStorage().getItem(SOFT_PIP_PLAYER_STATE_KEY);
    return value ? JSON.parse(value) : undefined;
}
/**
 * Clear the Soft PIP player state from session storage.
 */
export function clearPersistedPlayerState() {
    getSessionStorage().removeItem(SOFT_PIP_PLAYER_STATE_KEY);
}
